// Videos on media.polepole.be come in two sizes and a poster, named
// <name>-1080.mp4, <name>-720.mp4 and <name>-poster.webp. Any other URL is
// played as it is, with one source and no poster.
const SUFFIX = '-1080.mp4';

export const toVideoSources = (url: string) => {
  if (!url.endsWith(SUFFIX)) {
    return { desktop: url, mobile: undefined, poster: undefined };
  }

  const base = url.slice(0, -SUFFIX.length);

  return {
    desktop: url,
    mobile: `${base}-720.mp4`,
    poster: `${base}-poster.webp`,
  };
};
